/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationLinkViewModel } from './locationLinkViewModel';
import { PlaceOfServiceCodeLinkViewModel } from './placeOfServiceCodeLinkViewModel';
import { FinancialClassViewModel } from './financialClassViewModel';
import { NdcUnit } from './ndcUnit';
import { ProviderLinkViewModel } from './providerLinkViewModel';
import { HoldingIssue } from './holdingIssue';
import { DiagnosisCodeLinkViewModel } from './diagnosisCodeLinkViewModel';
import { ProcedureLinkViewModel } from './procedureLinkViewModel';
import { FinancialClassLinkViewModel } from './financialClassLinkViewModel';
import { ProcedureDiagnosisCodeHoldingViewModel } from './procedureDiagnosisCodeHoldingViewModel';
import { ProcedureResultHoldingViewModel } from './procedureResultHoldingViewModel';

export interface ProcedureTransactionHoldingDetailsViewModel {
  id?: string;
  datasetId?: string;
  sendingFacilityId?: string;
  patientHoldingId?: string | null;
  patientId?: string | null;
  visitId?: string | null;
  visitHoldingId?: string | null;
  procedureId?: string | null;
  procedureLinkId?: string | null;
  attendingProviderId?: string | null;
  attendingProviderLinkId?: string | null;
  referringProviderId?: string | null;
  referringProviderLinkId?: string | null;
  orderingProviderId?: string | null;
  orderingProviderLinkId?: string | null;
  primaryProviderId?: string | null;
  primaryProviderLinkId?: string | null;
  supervisingProviderId?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
  placeOfServiceCodeId?: string | null;
  placeOfServiceCodeLinkId?: string | null;
  locationId?: string | null;
  locationLinkId?: string | null;
  modifier1Id?: string | null;
  modifier2Id?: string | null;
  modifier3Id?: string | null;
  modifier4Id?: string | null;
  procedureAmount?: number | null;
  quantity?: number;
  insuranceAuthNumber?: string | null;
  accessionNumber?: string | null;
  nationalDrugCodeId?: string | null;
  drugUnit?: NdcUnit;
  drugQuantity?: number | null;
  drugAmount?: number | null;
  drugCode?: string | null;
  prescriptionNumber?: string | null;
  holdPatientBilling?: boolean | null;
  holdInsuranceBilling?: boolean | null;
  nocProcedureDescription?: string | null;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  claimComment?: string | null;
  financialClassId?: string | null;
  financialClassLinkId?: string | null;
  referringProviderRequired?: boolean;
  hasDemographicUpdates?: boolean;
  isChargeCentralApproved?: boolean;
  externalId?: string | null;
  issues?: Array<HoldingIssue> | null;
  procedureLink?: ProcedureLinkViewModel;
  attendingProviderLink?: ProviderLinkViewModel;
  referringProviderLink?: ProviderLinkViewModel;
  orderingProviderLink?: ProviderLinkViewModel;
  primaryProviderLink?: ProviderLinkViewModel;
  locationLink?: LocationLinkViewModel;
  placeOfServiceLink?: PlaceOfServiceCodeLinkViewModel;
  diagnosesLinks?: Array<DiagnosisCodeLinkViewModel> | null;
  procedureResultHolding?: ProcedureResultHoldingViewModel;
  diagnoses?: Array<ProcedureDiagnosisCodeHoldingViewModel> | null;
  financialClass?: FinancialClassViewModel;
  financialClassLink?: FinancialClassLinkViewModel;
  procedureOutput?: string | null;
  attendingOutput?: string | null;
  referringOutput?: string | null;
  diagnosesOutput?: string | null;
  locationOutput?: string | null;
  placeOfServiceOutput?: string | null;
  orderingOutput?: string | null;
}
